import { forwardRef } from 'react';

import { SpinnerStyle, SpinnerWrapper } from './styles';
import { defaultTheme } from './theme';
import { SpinnerProps } from './types';

const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = '15px', style, theme: _theme }, ref) => {
    const theme = { ...defaultTheme, ..._theme };

    return (
      <SpinnerWrapper ref={ref} style={style}>
        <SpinnerStyle size={size} theme={theme} />
      </SpinnerWrapper>
    );
  }
);

export default Spinner;
